import { valuesIn } from "lodash";
import { Organization, OrganizationMembership } from "../users/UserStore";

let ID = () => {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
};

interface ApplicationContext {
    currentOrganization: Organization;
    currentMembership: OrganizationMembership;
}

let context = {
    currentOrganization: new Organization(),
    currentMembership: new OrganizationMembership(),
} as ApplicationContext;

LoadFromStorage();

function LoadFromStorage() {
    let storage = localStorage.getItem("organization");
    if (storage) {
        try {
            let organization = JSON.parse(storage);
            if (organization != null && organization.id) {
                SetOrganization(organization);
            }
        } catch (e) {}
    }
}

function SaveToStorage(organization: Organization) {
    localStorage.setItem("organization", JSON.stringify(organization));
    localStorage.setItem("redirects", "0");
}

let subscriptions = {} as { [key: string]: (context: any) => void };

function dispatch() {
    valuesIn(subscriptions).forEach((s) => s(context));
}

export function Context() {
    return context;
}

export function GetContext(subscription: (context: ApplicationContext) => void) {
    let id = ID();
    if (subscription) {
        subscriptions[id] = subscription;
        if (context.currentOrganization.id) {
            subscription(context);
        }
    }
    return id;
}

export function UnsubscribeContext(id: string) {
    if (subscriptions[id]) delete subscriptions[id];
}

export function SetOrganization(organization: Organization) {
    context.currentOrganization = organization;
    SaveToStorage(organization);
    dispatch();
}

export function SetMembership(membership: OrganizationMembership) {
    context.currentMembership = membership;
    dispatch();
}
